// extracted by mini-css-extract-plugin
module.exports = {"container":"_9DTRznFrtZt6Ft297VG5d","groupsList":"_2mAAyezI1Wza2WqnYleRcb"};